export default __webpack_public_path__ + "ba9e2cd1e9aae26c7b644bc3e8463810.png";